// export const apiUrl = "http://localhost/pro-p%20local%20project/";
export const apiUrl = "https://pro-p-group.com/api/prop/";
// export const apiUrl = "http://localhost/api/prop/";